import React from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Paper,
  Typography,
  Divider,
  Stack,
  Grid,
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
const EmployeeAgreement = () => {
  const { state } = useLocation();
  const { employeeData } = state || {};
  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `${employeeData?.name}_Employment_Agreement`,
  });

  return (
    <Box sx={{ p: 4, backgroundColor: "#f4f6f8", minHeight: "100vh" }}>
      <Paper
        ref={componentRef}
        sx={{
          maxWidth: 900,
          mx: "auto",
          p: 5,
          backgroundColor: "#fff",
          borderRadius: "16px",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <img
            src="rectangle-9@2x.png"
            alt="MTTMG Logo"
            style={{ height: 80, marginBottom: 10 }}
          />
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", color: "#2f80ed" }}
          >
            Maa Tara Tarini Multi gym
          </Typography>
        </Box>

        <Typography
          variant="h5"
          align="center"
          sx={{ fontWeight: "bold", mb: 4 }}
        >
          Employment Agreement
        </Typography>

        <Typography paragraph>
          This Employment agreement (hereinafter, the “Agreement”) is entered
          into on this ______ day of ______, 20____, between Mr./Ms.{" "}
          <strong>{employeeData?.name}</strong> residing at{" "}
          <strong>{employeeData?.address}</strong> (hereinafter referred to as
          “Employee”) AND Mr. Sagar Parida, owner at Maa Tara Tarini Multi gym,
          having its principal office located at Plot no 167, E Canal Rd,
          Dayanandnagar, Bomikhal, Rasulgarh, Bhubaneswar, Odisha 751010
          (hereinafter referred to as the “Employer”).
        </Typography>

        <Typography paragraph>
          Whereas, the Employer has extended an offer of employment to the
          Employee, and the Employee accepts such offer, on the terms and
          conditions set forth below:
        </Typography>

        <Typography paragraph>
          Now, therefore, in consideration of the matters described above and of
          the mutual benefits and obligations set forth in this agreement, the
          parties agree as follows:
        </Typography>

        <Typography variant="h6">1. Employment:</Typography>
        <Typography paragraph>
          a. Employer hereby employs Employee as{" "}
          <strong>{employeeData?.designation}</strong> and Employee accepts such
          employment with Employer on the terms and conditions set forth in this
          agreement.
        </Typography>
        <Typography paragraph>
          b. The place of Employment shall be Bhubaneswar.
        </Typography>

        <Typography variant="h6">2. Terms of Employment:</Typography>
        <Typography paragraph>
          This agreement is effective as of the ______ day of ______ 20__, and
          shall remain in effect for the next one year. The Employee commits to
          serve the organization for a minimum period of one year. The parties
          agree to review this agreement at least 30 days before expiry. Post
          this period, the employment shall become month-to-month unless
          otherwise terminated in writing.
        </Typography>

        <Typography variant="h6">
          3. Employee Undertaking, Duties and Commitments:
        </Typography>
        <Typography paragraph>
          a. Employer has the power to determine Employee's specific duties, and
          the manner in which Employee carries out his/her duties.
        </Typography>
        <Typography paragraph>
          b. Employer has discretion in setting the days of the week and hours
          in which Employee is to perform Employee’s duties. Employee agrees to
          devote the time and necessary attention to perform Employee’s duties
          in a satisfactory manne.
        </Typography>
        <Typography paragraph>
          c. The Employee undertakes, commits, agrees and covenants that as an
          Employee of the Organisation, he or she shall not accept any other
          project or commence or continue any freelance job during the course of
          his or her employment with the Organization.
        </Typography>
        <Typography paragraph>
          d.The Employee shall apply and maintain the highest standards of
          personal conduct and integrity and comply with all Organisation
          policies and procedures, as amended from time to time.
        </Typography>
        <Typography paragraph>
          e. The Employee commits to serve the Organisation for a minimum period
          of one years from date of engagement.
        </Typography>

        <Typography variant="h6">4. Remuneration:</Typography>
        <Typography paragraph>
          During the term of this Agreement, the Employer shall pay to Employee
          a monthly salary of Rs <strong>{employeeData?.salary}</strong> for the
          services rendered on employer`s behalf .
        </Typography>

        <Typography variant="h6">5. Work Facilities:</Typography>
        <Typography paragraph>
          Employer shall provide all the equipment and related support necessary
          to performance of Employee’s duties pursuant to the agreement
        </Typography>

        <Typography variant="h6">6. Holiday and Absence:</Typography>
        <Typography paragraph>
          {" "}
          a. Holidays:Employee shall be entitled to the same holidays as
          authorized by the organisation for its other Employees.
        </Typography>
        <Typography paragraph>
          b. Sick Days and Personal Absence Days.Employee shall be entitled to
          the same number of sick days and personal absence days as authorized
          by the organisation for its other Employees. Employee shall intimate
          about intended leave to the Employer two days in advance of such
          leave.
        </Typography>

        <Typography variant="h6">7. Trade Secrets:</Typography>
        <Typography paragraph>
          Employee agrees not to disclose to any person or entity any
          information regarding the business of Employer, including its
          customers, products, prices, and manner of operations, without first
          obtaining the Employer written consent. If Employee breaches this
          section, Employer shall be entitled, among other remedies, to
          injunctive relief prohibiting Employee from disclosing such
          information. This section shall survive termination of this Agreement
        </Typography>

        <Typography variant="h6">8. Noncompetition:</Typography>
        <Typography paragraph>
          Post-termination, Employee shall not work in health club industry
          within ___ km radius for one year. Breach entitles Employer to legal
          remedy.
        </Typography>

        <Typography variant="h6">9. Termination:</Typography>
        <Typography paragraph>
          a. Employee may resign with 3 months’ notice or ₹15,000 compensation.
        </Typography>
        <Typography paragraph>
          b. Employer may terminate after confirmation with 30-day notice or
          half month salary.
        </Typography>
        <Typography paragraph>
          c. Employer may terminate immediately on misconduct or breach of
          trust.
        </Typography>

        <Typography variant="h6">10. Consequences of Termination:</Typography>
        <Typography paragraph>
          Employee shall return all company property. Failure is deemed criminal
          breach of trust.
        </Typography>

        <Typography variant="h6">11. Notice:</Typography>
        <Typography paragraph>
          Any notice required pursuant to this agreement shall be in writing,
          and sent by registered or certified mail to Employer’s principal
          office and Employee’s last known address
        </Typography>

        <Typography variant="h6">12. Modification:</Typography>
        <Typography paragraph>
          This agreement represents the entire agreement between Employer and
          Employee. No modification of this Agreement is Valid unless it is in
          writing and signed by parties.
        </Typography>

        <Typography variant="h6">13. Assignment:</Typography>
        <Typography paragraph>This agreement is not assignable.</Typography>

        <Typography variant="h6">14. Indemnification:</Typography>
        <Typography paragraph>
          The Employee shall indemnify the Employer against any and all
          expenses, including amounts paid upon judgments, counsel fees,
          penalties and fines, and amounts paid in settlement (before or after
          suit is commenced), incurred by the Employer in connection with
          his/her defense or settlement of any claim, action, suit or proceeding
          in which he/she is made a party or which may be asserted against
          his/her by reason of his/her employment or the performance of duties
          in this Agreement. Such indemnification shall be in addition to any
          other rights to which those indemnified may be entitled under any law,
          by-law, agreement, or otherwise.
        </Typography>

        <Typography variant="h6">15. Entire Agreement:</Typography>
        <Typography paragraph>
          This Agreement, together with other writings signed by the Parties
          expressly stated to be supplemental hereto and together with any
          instruments to be executed and delivered pursuant to this Agreement,
          constitutes the agreement between the Parties and supersedes all prior
          understandings and writings, and may be amended or changed only by a
          writing signed by the Parties hereof.
        </Typography>

        <Typography variant="h6">
          16. Governing Law and Jurisdiction:
        </Typography>
        <Typography paragraph>
          This Agreement shall be construed, interpreted and applied in
          accordance with, and shall be governed by, the laws applicable in
          India. The courts at Odisha shall have the exclusive jurisdiction to
          entertain any dispute or suit arising out of or in relation to this
          Agreement
        </Typography>

        <Box sx={{ mt: 6 }}>
          <Typography paragraph>
            WITNESS our signatures as of the day and date first above stated.
          </Typography>

          <Grid container spacing={4} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Employee
              </Typography>
              <Typography variant="body1">
                ____________________________ <br />
                <strong>{employeeData?.name}</strong>
                <br />
                Employee Signature
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Employer (Owner & Proprietor)
              </Typography>
              <Box
                component="img"
                src={`${process.env.PUBLIC_URL || ""}/images/ChatGPT.png`}
                alt="Mr. Sagar Parida, Owner signature"
                sx={{
                  display: "block",
                  maxWidth: "min(280px, 100%)",
                  maxHeight: { xs: 100, sm: 120 },
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                  objectPosition: "left center",
                  mb: 1.5,
                }}
              />
              <Typography variant="body1">
                ____________________________ <br />
                <strong>Mr. Sagar Parida</strong>
                <br />
                For Maa Tara Tarini Multi gym
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      <Box sx={{ textAlign: "center", mt: 4 }}>
  <Stack direction="row" spacing={2} justifyContent="center">
    {/* Back Button */}
    <Button
      variant="outlined"
      onClick={() => window.history.back()} // or use navigate(-1) if you're using useNavigate
      sx={{
        borderColor: "#2f80ed",
        color: "#2f80ed",
        fontWeight: "bold",
        borderRadius: "8px",
        px: 4,
        py: 1.5,
        "&:hover": {
          backgroundColor: "#e3f2fd",
        },
      }}
    >
      Back
    </Button>

    {/* Download Button */}
    <Button
      variant="contained"
      onClick={handlePrint}
      sx={{
        backgroundColor: "#2f80ed",
        color: "#fff",
        fontWeight: "bold",
        borderRadius: "8px",
        px: 4,
        py: 1.5,
        "&:hover": {
          backgroundColor: "#1c5fc1",
        },
      }}
    >
      Download Agreement PDF
    </Button>
  </Stack>
</Box>
    </Box>
  );
};

export default EmployeeAgreement;
